module.exports = __webpack_public_path__ + "static/media/dashboard-icon.457961e8.svg";